module.exports = __webpack_public_path__ + "img/48740351000165.36cd74bf.png";